import {
  IStateCart,
  IPricing,
  IModel,
} from "@/apps/merchant3/models/IStateCart";
import { IOptionDropdown } from "@/types/dropdown";

const getters = {
  getSelectedModel: (state: IStateCart): IOptionDropdown | null => {
    if (state.friendlyDeviceName && state.deviceModelId) {
      return {
        name: state.friendlyDeviceName,
        code: `${state.deviceModelId}`,
      } as IOptionDropdown;
    }
    return null;
  },
  getSelectedBrand: (state: IStateCart): IOptionDropdown | unknown => {
    if (state.deviceFamilyName && state.deviceFamilyId) {
      return {
        name: state.deviceFamilyName,
        code: state.deviceFamilyId,
      } as IOptionDropdown;
    }
    return null;
  },
  getRetailPrice: (state: IStateCart): number => {
    if (state.retailPrice) {
      return state.retailPrice;
    }
    return 0;
  },

  getDownPayment: (state: IStateCart): string => {
    if (state.downPayment) {
      return `${state.downPayment}`;
    }
    return "0";
  },

  getSelectedModelDropdown: (state: IStateCart): IOptionDropdown[] => {
    return state.selectedDeviceModelsDropdown;
  },

  getSelectedOffer: (state: IStateCart): IPricing | unknown => {
    if (state.months && state.pricing && state.pricing[state.months]) {
      return state.pricing[state.months];
    }
    return null;
  },

  deviceModelOptions: (state: IStateCart): IModel[] => {
    const currentBrand = state.allDevices.find(
      (brand) => brand.code === state.selectedBrandCode
    );
    return currentBrand && currentBrand.models ? currentBrand.models : [];
  },
  getPricing: (state: IStateCart): IPricing => state.pricing || {},

  hasActiveFeature:
    (state: IStateCart) =>
    (activeFeature: string): boolean => {
      return !!(
        state.activeFeatures && state.activeFeatures.includes(activeFeature)
      );
    },
};

export default getters;
